const partnerPaymentsFeesConfirmationFormResources = {
    labelForStartupFeeAmount: 'Startup Fee Amount',
    labelForRenewalFeeAmount: 'Renewal Fee Amount',
    labelForFacilityAccessFeeAmount: 'Facility Access Fee Amount',
    labelForOneTimeFeeAmount: 'One-Time Fee Amount',
    labelForOneTimeFeeReason: 'One-time Fee Reason',
};

export default partnerPaymentsFeesConfirmationFormResources;
